import Select from 'react-select';
import tools from '../../../utils/tools';

const Relations = ({form, setForm, products}) => {

  return (
    <div className="AddInfoContainer">
      <label>محصولات مشابه</label>
      <Select options={tools.selectFormatter(products, 'id', 'title')} value={tools.selectFormatter(products.filter(e => form?.similar?.includes(e.id.toString())), 'id', 'title')} className="width100" isMulti={true}
              onChange={(selected) => setForm((prev) => ({...prev, similar: selected.map(e => e.value.toString())}))}
      />
      <label>محصولات مورد نیاز</label>
      <Select options={tools.selectFormatter(products, 'id', 'title')} value={tools.selectFormatter(products.filter(e => form?.required?.includes(e.id.toString())), 'id', 'title')} className="width100" isMulti={true}
              onChange={(selected) => setForm((prev) => ({...prev, required: selected.map(e => e.value.toString())}))}
      />
    </div>
  );

};

export default Relations;
